"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgKeyOutline = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M8 22.003a6 6 0 11.565-11.973l7.622-7.622c.145-.158.289-.268.432-.33.143-.063.33-.088.562-.075H21c.67 0 1.005.334 1.005 1.002v3.998c0 .667-.335 1-1.005 1h-2v2c0 .667-.333 1-1 1h-2.29l-2.337 2.327A6 6 0 018 22.003zm0-2a4 4 0 003.466-5.998c-.06-.105-.282-.503-.28-.878.003-.25.1-.489.292-.716l2.979-2.975c.143-.149.275-.258.396-.328.12-.07.29-.105.508-.105h1.637v-2c0-.666.336-1 1.007-1 .67 0 1.337 0 2-.005V4.003h-2.592L9.782 11.64c-.236.224-.464.345-.685.363-.33.028-.942 0-1.097 0a4 4 0 100 8zm-1-2a1 1 0 110-2 1 1 0 010 2z' }))); };
exports.default = SvgKeyOutline;
//# sourceMappingURL=KeyOutline.js.map